import $ from 'jquery'
import 'slick-carousel'
export default () => {

  const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg viewBox="0 0 47 47">
  ${$('#icon-menu-arrow')[0].innerHTML}</svg></button>`;
  const nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button">
  <svg viewBox="0 0 47 47">
  ${$('#icon-menu-arrow')[0].innerHTML}</svg></button>`;

    $('.js-slider').on('init', function () {
      setTimeout(function() {
          $('.js-slider').css({
            height: 'auto',
            visibility: 'visible',
            touchThreshold: 2,
            swipeToSlide: true,
            draggable: true,
            swipe: true

          });
        }, 200);
    });

    $('.js-slider').slick();

    var $slider = $('.js-slider');

    function checkSlides() {
        var totalWidth = 0;
        $slider.children().each(function() {
            totalWidth += $(this).outerWidth(true); // Calculate total slide width
        });

        if (totalWidth <= $slider.width()) {
          $slider.slick('slickGoTo', 0);
        } else {
          $slider.slick('slickGoTo', 1);
        }
    }

    // Run on page load and resize
    checkSlides();
    $(window).on('resize', checkSlides);
}